import { Button, ButtonSize, ButtonVariant } from '@farmasiet/frontendcore-reactcomponents';
import * as React from 'react';
import { FC } from 'react';

import { getTranslation, keys } from '../../../../Resources/Translations';
import { Modal, ModalButtons, ModalButtonsDirection, ModalHeading } from '../../../ReactComponents/Modal/Modal';

interface EmailSuggestionModalProps {
    isVisible: boolean;
    insertedEmail: string;
    suggestedEmail: string;

    onRejected: () => void;
    onAccepted: () => void;
    onCancelled: () => void;
}

export const EmailSuggestionModal: FC<EmailSuggestionModalProps> = (props) => {
    return (
        <Modal open={props.isVisible} onClose={props.onCancelled}>
            <ModalHeading>{getTranslation(keys['emailSuggestion.header'])}</ModalHeading>

            <div className="EmailSuggestionModal__MessageContainer">
                <span>{getTranslation(keys['emailSuggestion.incorrectAddress'], [props.insertedEmail])}</span>
                <br />
                <span>
                    {props.suggestedEmail ? (
                        <>
                            {getTranslation(keys['emailSuggestion.didYouMeanToUse'])} <b>{props.suggestedEmail}</b>?
                        </>
                    ) : (
                        getTranslation(keys['emailSuggestion.areYouSure'])
                    )}
                </span>
            </div>

            <ModalButtons direction={ModalButtonsDirection.Column}>
                <Button size={ButtonSize.Medium} variant={ButtonVariant.Link} onClick={props.onRejected}>
                    {getTranslation(
                        keys[props.suggestedEmail ? 'emailSuggestion.withSuggestionRejectButton' : 'emailSuggestion.withoutSuggestionRejectButton']
                    )}
                </Button>
                <Button size={ButtonSize.Medium} variant={ButtonVariant.Primary} onClick={props.onAccepted}>
                    {getTranslation(
                        keys[props.suggestedEmail ? 'emailSuggestion.withSuggestionAcceptButton' : 'emailSuggestion.withoutSuggestionAcceptButton']
                    )}
                </Button>
            </ModalButtons>
        </Modal>
    );
};
